<template>
    <v-dialog v-model="commentDialog" eager width="500">
        <template v-slot:activator="{ on, attrs }">
            <span style="justify-content: space-around; display: flex; margin-top: -3px;">
                <v-tooltip content-class="pa-0" left max-width="70%" v-model="show">
                    <template v-slot:activator="tooltip">
                        <v-btn
                            icon
                            small
                            v-on="tooltip.on"
                        >
                            <v-badge v-if="commentCount > 0" dot color="success" :content="commentCount" :offset-x="9" :offset-y="9">
                                <v-icon
                                    color="#355b7f"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >mdi-comment</v-icon>
                            </v-badge>
                            <v-icon v-else
                                    color=""
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >mdi-comment</v-icon>
                        </v-btn>
                    </template>
                    <v-card @click="show = !show">
                        <v-simple-table
                            class="text-size"
                            v-if="commentCount > 0"
                            fixed-header
                            height="100%"
                            style="width: 100%; max-width: 100%;"
                        >
                            <thead>
                                <tr>
                                    <th class="text-size" scope="col">
                                        {{ $t("User") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("Comment") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("Created") }}
                                    </th>
                                    <th class="text-size" scope="col">
                                        {{ $t("Edited") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(entry, index) in ownComments">
                                    <tr
                                        :key="'comment-' + index"
                                    >
                                        <td class="text-size valign">{{ entry.userName }}</td>
                                        <td class="text-size">{{ entry.comment }}</td>
                                        <td class="text-size">{{ entry.created }}</td>
                                        <td class="text-size">{{ entry.edited }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </v-simple-table>
                        <span v-else class="d-block pa-3 text-size">
                            {{ $t("No comments") }}
                        </span>
                    </v-card>
                </v-tooltip>
            </span>
        </template>
        <v-card>
            <v-card-title>
                <v-row no-gutters>
                    <v-col v-if="ownComments[this.user.id]" cols="auto">
                        {{ $t("Edit comment") }}
                    </v-col>
                    <v-col v-else cols="auto">
                        {{ $t("Add comment") }}
                    </v-col>
                    <v-spacer />

                    <v-col cols="auto">
                        <v-btn
                            class="text-size"
                            text
                            color="primary"
                            @click="commentDialog = false"
                        >
                            {{ $t("Close") }}
                        </v-btn><v-btn
                            class="text-size"
                            text
                            color="primary"
                            @click="saveComment"
                        >
                            {{ $t("Save") }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-textarea outlined auto-grow clearable v-model="userComment"/>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import axios from "axios";
import i18n from "../../i18n";
import {popupShowTime} from "../../plugins/constants";

export default {
    name: "DependencyComment",
    props: {
        dependencyId: {
            type: Number,
            default: undefined
        },
        comments: {
            type: Object,
            default: () => []
        }
    },

    data() {
        return {
            ownComments: this.comments,
            user: this.$auth.user(),
            commentCount: Object.keys(this.comments).length,
            commentDialog: false,
            userComment: (this.comments[this.$auth.user().id] || {}).comment || '',
            show: false,
        };
    },

    watch: {
        ownComments() {
            this.commentCount = Object.keys(this.ownComments).length
        }
    },

    methods: {
        saveComment() {
            let params = new FormData();
            params.append('dependencyId', this.dependencyId);
            params.append('comment', this.userComment);
            console.log(this.dependencyId, this.userComment)
            axios
                .post('cedexSettings/changeLineComment', params)
                .then(response => {
                    if (
                        response.status === 200
                        && response.data.success
                    ) {
                        this.updateUserComment(this.userComment);
                        this.$emit('showMessage', i18n.t('Comment saved.'), 'success', popupShowTime);
                        this.commentDialog = false
                    } else {
                        this.$emit('showMessage', i18n.t('Comment saving failed.'), 'error', popupShowTime);
                    }
                })
                .catch(error => {
                    this.$emit('showMessage', i18n.t('Comment saving failed.'), 'error', popupShowTime);
                    console.log(error);
                });
        },

        updateUserComment(comment)
        {
            let date = new Date();
            let nowDateString = date.getFullYear() + '-' +
                ('0' + (date.getMonth()+1)).slice(-2) + '-' +
                ('0' + date.getDate()).slice(-2) + ' ' +
                ('0' + date.getHours()).slice(-2) + ':' +
                ('0' + date.getMinutes()).slice(-2) + ':' +
                ('0' + date.getSeconds()).slice(-2);

            if (
                typeof comment !== 'string'
                || comment.trim() === ''
            ) {
                comment = '';
                this.$delete(this.ownComments, this.user.id);
            } else {
                comment = comment.trim();
                let userComment = this.ownComments[this.user.id];
                if (userComment) {
                    userComment.comment = comment;
                    userComment.edited = nowDateString;
                } else {
                    userComment = {
                        comment:  comment,
                        created:  nowDateString,
                        edited:   nowDateString,
                        userId:   this.user.id,
                        userName: this.user.name
                    }
                }
                this.$set(this.ownComments, this.user.id, userComment);
            }

            this.userComment = comment;
            this.$emit('updateComment', this.dependencyId, this.user.id, this.ownComments[this.user.id]);
        }
    }
};
</script>

<style scoped>
.text-size {
    font-size: 12px !important;

    max-width: 20vw;
    word-wrap: break-word;
}
</style>
